import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function logout({ data, roleName }) {
  pushClevertapEvent('Logout', {
    'User ID': data.id,
    'Active Subscription': data.already_subscribed,
    'Is Business Owner': data.is_owner,
    Email: data.email,
    Role: roleName,
  });
}
